import BaseService from 'services/BaseService';
import DataHelpers from 'helpers/DataHelpers';
import moment from 'moment';

//-------------------------------------------------------------------------------------------------------------------

export default class BookingService
    extends BaseService {

    static async list(param) {
        return BaseService.callAPI('booking/list', param);
    }

    static async listPaidMonths(param) {
        return BaseService.callAPI('booking/list-paid-months', param);
    }

    static async excel(param, isEnquiries) {
        return BaseService.callAPI('booking/list-excel', {
            ...param,
            isDownload: true,
            fileName: (isEnquiries ? 'Enquiries.xlsx' : 'Bookings.xlsx'),
            isEnquiries
        });
    }

    static async get(id) {
        return BaseService.callAPI('booking/get/' + id);
    }

    static async getExpectedValue(id) {
        return BaseService.callAPI('booking/get-expected-value/' + id);
    }

    static async save(booking) {
        booking = DataHelpers.stripTimeZoneInformation(booking, [
            'date', 'enquiryDate'
        ]);
        return BaseService.callAPI('booking/save', booking);
    }

    static async delete(id) {
        return BaseService.callAPI('booking/delete/' + id);
    }

    static async archive(id) {
        return BaseService.callAPI('booking/archive/' + id);
    }

    static async ignoreInvoice(id) {
        return BaseService.callAPI('booking/ignore-invoice/' + id);
    }

    static async importPreflight(file) {
        return BaseService.postFile('booking/import-preflight', file);
    }

    static async import(guid, fileName, selectBookingActions, availabilityActions, isSelected) {
        return BaseService.callAPI('booking/import', {
            guid, fileName, selectBookingActions, availabilityActions, isSelected
        });
    }

    static async listMonthlyStats(param) {
        return BaseService.callAPI('booking/list-monthly-stats', param);
    }

    static async listUnbilledDays() {
        return BaseService.callAPI('booking/list-unbilled-days');
    }

    static async getATPPOInfo(id) {
        return BaseService.callAPI('booking/get-atp-po-info/' + id);
    }

    static async saveATPPOInfo(atpInfo) {
        return BaseService.callAPI('booking/save-atp-po-info', atpInfo);
    }

    static async submitEnquiry(enquiry) {
        return BaseService.callAPI('booking/submit-enquiry', enquiry);
    }

    static async listCurrent() {
        return BaseService.callAPI('booking/list-current');
    }

    static async getCSATResponse(id) {
        return BaseService.callAPI('booking/get-csat-response/' + id);
    }

}
